import { Record as record } from 'immutable';
import { construct, fields } from '../../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';

const schema = {
    id: [fields.string],
    stations: [fields.bool],
    price: [fields.bool],
    bookSize: [fields.bool],
    ticketNumber: [fields.bool],
    oysterNumber: [fields.bool],
    smartcardNumber: [fields.bool],
    purchaseLocation: [fields.bool],
    pairWithOther: [fields.bool],
    pairWithSelf: [fields.bool],
    optionalReturn: [fields.bool],
    evidenceNotRequired: [fields.bool],
    evidenceIsOptional: [fields.bool, false],
    returnMustMatch: [fields.bool],
    weeklyExclusive: [fields.bool]
};

export default class NonSeasonTicketType extends record(getDefaults(schema)) {
    static fromJSON(json = {}) {
        return construct(NonSeasonTicketType, json, getResolvers(schema));
    }

    canPair() {
        return Boolean(this.pairWithSelf || this.pairWithOther);
    }

    mustPair() {
        return Boolean(this.canPair() && !this.optionalReturn);
    }

    pairsWith(otherType) {
        if (this === otherType) {
            return Boolean(this.pairWithSelf);
        }
        return this.pairWithOther && otherType.pairWithOther;
    }
}



// WEBPACK FOOTER //
// ./delay-repay/src/records/compensation/NonSeasonTicketType.js